<template>
    <div class="p-6 bg-gray-50 min-h-screen">
      <h1 class="text-2xl font-bold text-gray-800 mb-6">Список заказов</h1>
      <div v-if="loading" class="text-center">
        <span class="text-gray-600 text-lg">Загрузка...</span>
      </div>
      <div v-else-if="orders.length === 0" class="text-center">
        <span class="text-gray-600 text-lg">Нет заказов для отображения</span>
      </div>
      <div v-else>
        <table class="w-full table-auto border-collapse shadow-md rounded-lg overflow-hidden">
          <thead>
            <tr class="bg-gray-200 text-left text-sm font-semibold text-gray-700">
              <th class="px-4 py-3">ID</th>
              <th class="px-4 py-3">Статус</th>
              <th class="px-4 py-3">Дата создания</th>
              <th class="px-4 py-3">Дата обновления</th>
              <th class="px-4 py-3">Исполнитель</th>
              <th class="px-4 py-3">Пациент</th>
              <th class="px-4 py-3">Цена</th>
              <th class="px-4 py-3">Тип</th>
              <th class="px-4 py-3">Действия</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="order in orders"
              :key="order.id"
              class="border-b hover:bg-gray-100 transition"
            >
              <td class="px-4 py-3 text-sm text-gray-700">{{ order.id }}</td>
              <td class="px-4 py-3 text-sm text-gray-700">{{ translateStatus(order.status) }}</td>
              <td class="px-4 py-3 text-sm text-gray-700">
                {{ formatDate(order.created_at) }}
              </td>
              <td class="px-4 py-3 text-sm text-gray-700">
                {{ formatDate(order.updated_at) }}
              </td>
              <td class="px-4 py-3 text-sm text-gray-700">{{ order.performer }}</td>
              <td class="px-4 py-3 text-sm text-gray-700">
                {{ order.patient }} {{ order.patient_last_name }}
              </td>
              <td class="px-4 py-3 text-sm text-gray-700">
                {{ formatPrice(order.price) }}
              </td>
              <td class="px-4 py-3 text-sm text-gray-700 capitalize">
                {{ translateType(order.type) }}
              </td>
              <td class="px-4 py-3 text-sm text-gray-700">
                <button
                class="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
                @click="() => { console.log('Кнопка нажата'); refundOrder(order.id, order.type); }"
                >
                Вернуть деньги
                </button>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </template>

  <script>
  import { getAllOrders, refundOrderById } from "@/services/suppotService";

  export default {
    name: "OrdersPage",
    data() {
      return {
        orders: [], // Список заказов
        loading: true, // Индикатор загрузки
      };
    },
    methods: {
      async fetchOrders() {
        try {
          const response = await getAllOrders();
          if (response.data.success) {
            this.orders = response.data.data;
          } else {
            console.error("Ошибка при загрузке данных", response.data);
          }
        } catch (error) {
          console.error("Ошибка при запросе к API:", error);
        } finally {
          this.loading = false;
        }
      },
      formatDate(date) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(date).toLocaleDateString("ru-RU", options);
      },
      formatPrice(price) {
        return `${parseFloat(price).toFixed(0)} ₸`;
      },
      translateStatus(status) {
        const statuses = {
          pending: "В ожидании",
          "in progress": "В процессе",
          accepted: "В процессе",
          canceled: "Отменен",
          completed: "Завершен",
        };
        return statuses[status.toLowerCase()] || "Неизвестный статус";
      },
      translateType(type) {
        const types = {
          doctor: "Врач",
          nurse: "Медсестра",
        };
        return types[type.toLowerCase()] || "Неизвестный тип";
      },
      async refundOrder(orderId, orderType) {
     console.log("Refunding order:", orderId, orderType);
        try {
        const response = await refundOrderById(orderId, orderType);
        if (response.data.success) {
        alert("Деньги успешно возвращены!");
        this.fetchOrders();
        } else {
        alert("Ошибка при возврате: " + response.data.message);
        }
    } catch (error) {
        alert("Произошла ошибка при возврате средств: " + error.message);
    }
},
    },
    mounted() {
      this.fetchOrders();
    },
  };
  </script>

  <style scoped>
  </style>
